import { WorldpayCustomisationBorder } from './worldpay-customisation-border.interface';

export interface WorldpayCustomisationPage {
  backgroundColor?: string;
  border?: WorldpayCustomisationBorder;
  color?: string;
  fonts?: string[];
}
